import { normalizeTankCode } from "../domain/inventory";

export type TankQrPayloadResult =
  | { kind: "valid"; tankCode: string }
  | { kind: "invalid"; reason: "empty" | "not_tank_code" };

export function parseTankQrPayload(raw: string): TankQrPayloadResult {
  const trimmed = raw.trim();

  if (!trimmed) {
    return { kind: "invalid", reason: "empty" };
  }

  const tankCode = normalizeTankCode(trimmed);

  if (!tankCode) {
    return { kind: "invalid", reason: "not_tank_code" };
  }

  return { kind: "valid", tankCode };
}

export const QR_LABEL_SIZE_MM = 50;

export function canonicalTankQrPayload(tankCode: string): string {
  const parsed = parseTankQrPayload(tankCode);

  if (parsed.kind !== "valid") {
    throw new Error("QR_TANK_CODE_INVALID");
  }

  return parsed.tankCode;
}
